import React from 'react';
import styled from 'styled-components';
import Window from '../Window';
import { FileText } from 'lucide-react';

const TextFileContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fa;
`;

const EditorContent = styled.div`
  flex: 1;
  padding: 20px;
  background: white;
  margin: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  white-space: pre-wrap;
  overflow-y: auto;
  border: 1px solid #e9ecef;
`;

const TextFileApp = ({ fileName, content, ...windowProps }) => {
  return (
    <Window {...windowProps} size={{ width: 500, height: 400 }}>
      <TextFileContainer>
        <EditorContent>
          {content}
        </EditorContent>
      </TextFileContainer>
    </Window>
  );
};

export default TextFileApp;
